export const createLoginRedirectUrl = (loginUrl: string): string =>
  `${loginUrl}${window.location.href}`;
